export class TilePosState {
  constructor() {
    this.x = 0;
    this.y = 0;
    this.valid = false;
  }
}
